import React from "react"
import {useSelector} from "react-redux";
import {Button as MuiButton} from "@material-ui/core";
import classNames from "classnames"

const BootstrapButton = ({
                           id,
                           name,
                           type,
                           onClick,
                           disabled,
                           className,
                           bootstrapVariant,
                           children
                         }) => {
  return <button
    id={id}
    name={name}
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={classNames(className, "btn", bootstrapVariant)}
  >
    {children}
  </button>
}

const MaterialUiButton = ({
                            id,
                            name,
                            type,
                            onClick,
                            disabled,
                            className,
                            muiColor,
                            variant,
                            children
                          }) => {
  return <MuiButton
    id={id}
    name={name}
    type={type}
    variant={variant}
    color={muiColor}
    onClick={onClick}
    disabled={disabled}
    className={className}
  >
    {children}
  </MuiButton>
}

const FlaveButton = (props) => {
  const formFieldStyle = useSelector(state => state.form_field_style)

  switch (formFieldStyle) {
    case "material_ui":
      return <MaterialUiButton {...props} variant={"contained"}/>
    case "material_ui_outlined":
      return <MaterialUiButton {...props} variant={"outlined"}/>
    case "material_ui_filled":
      return <MaterialUiButton {...props} variant={"contained"}/>
    case "boostrap_vertical":
      return <BootstrapButton {...props} variant={"vertical"}/>
    case "boostrap_horizontal":
    default:
      return <BootstrapButton {...props} variant={"horizontal"}/>
  }
}

export default FlaveButton
